import { render, staticRenderFns } from "./InjectionPageModal.vue?vue&type=template&id=22098874"
import script from "./InjectionPageModal.vue?vue&type=script&lang=js"
export * from "./InjectionPageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports